import { inject } from '@angular/core'

import { Actions, createEffect, ofType } from '@ngrx/effects'

import { catchError, map, of, switchMap } from 'rxjs'

import { ReusableFunctionApiService } from '../../api/reusable-functions.api'
import { mapResourcesList } from '../../entities/application.entity'
import { ToastMessageService } from '../../services/toast-message.service'
import { ReusableFunctionsActions } from '../actions/reusable-functions.actions'

export const getReusableFunctions$ = createEffect(
  (
    actions$ = inject(Actions),
    toastMessageService = inject(ToastMessageService),
    reusableFunctionsApi = inject(ReusableFunctionApiService)
  ) =>
    actions$.pipe(
      ofType(ReusableFunctionsActions.getReusableFunctions),
      switchMap(() =>
        reusableFunctionsApi.getAllReusableFunctions().pipe(
          map(({ resourceContent, manifestInfo }) => {
            const manifestInfoMap = manifestInfo.reduce((acc, curr) => {
              acc[curr.resId] = curr
              return acc
            }, {})
            const reusableFunctions = mapResourcesList({ resourceContent }).map((rf) => ({
              ...rf,
              manifestInfo: manifestInfoMap[rf.resourceId],
            }))
            return ReusableFunctionsActions.getReusableFunctionsSuccess({
              reusableFunctions,
            })
          }),
          catchError((err) => {
            toastMessageService.showErrorMessage(
              err?.error?.title ?? 'Failed to get reusable functions'
            )
            return of(ReusableFunctionsActions.getReusableFunctionsFailure())
          })
        )
      )
    ),
  {
    functional: true,
  }
)
